import { addDays } from '../dateUtils';

interface HeaderMonthsProps {
  chartStart: Date;   // always a Monday
  dayCount: number;   // always a multiple of 7
  dayWidth: number;   // per-day column width for the active zoom level
}

interface MonthSegment {
  label: string;
  days: number;
}

const monthFmt = new Intl.DateTimeFormat('default', {
  month: 'short',
  year: 'numeric',
});

function buildMonthSegments(chartStart: Date, dayCount: number): MonthSegment[] {
  const segments: MonthSegment[] = [];
  let key = '';

  for (let i = 0; i < dayCount; i++) {
    const d = addDays(chartStart, i);
    const k = `${d.getFullYear()}-${d.getMonth()}`;
    if (k !== key) {
      segments.push({ label: monthFmt.format(d), days: 0 });
      key = k;
    }
    segments[segments.length - 1].days += 1;
  }
  return segments;
}

export default function HeaderMonths({ chartStart, dayCount, dayWidth }: HeaderMonthsProps) {
  const segments = buildMonthSegments(chartStart, dayCount);
  return (
    <div style={{ overflow: 'hidden', height: '100%', borderBottom: '1px solid #e0e0e0', boxSizing: 'border-box' }}>
      <div id="gantt-head-track" style={{ display: 'flex', height: '100%', willChange: 'transform' }}>
        {segments.map((seg, i) => {
          const w = seg.days * dayWidth;
          return (
            <div
              key={i}
              style={{
                width: w,
                minWidth: w,
                borderRight: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#5f6368',
                fontWeight: 500,
                boxSizing: 'border-box',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {seg.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}